module.exports = __webpack_public_path__ + "assets/img/7.d2343e0e.png";